module.exports = __webpack_public_path__ + "img/pro.3e592ca6.png";